import { useEffect, useState } from 'react';
import Retailers from './Retailers'
import axios from 'axios';
import you from '../images/boy.png';
import bot from '../images/happy.png';
const RetailerCities = () => {
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState("");
    const [showButton, setShowButton] = useState(false);
    const [showFrame, setShowFrame]=useState(false);
    const [time] =useState(new Date());
  
    useEffect(() => {
      axios
        .get("https://dairy-api-kzjx.onrender.com/cities") // Fetching cities from backend
        .then((response) => {
          if (response.data.cities?.length > 0) {
            setCities(response.data.cities);
          } else {
            alert("No cities found.");
          }
        })
        .catch((error) => {
          console.error("Error fetching cities:", error);
          alert("Failed to fetch cities.");
        });
    }, []);
  
    const handleCityChange = (event) => {
      setSelectedCity(event.target.value);
      setShowButton(true);
    };
  
    const handleSubmit = () => {
      setShowFrame(true);
    };
  
    return(
        <>
         <div className="you-time animated-frame">
            <img src={you} alt="boy" className="boy" />
            You {time?.toLocaleTimeString()}</div>
          <div className="you-message">
            <div className="frame2 animated-frame"><b>Delivery Partners</b></div>
          </div>

          <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
          </div>
            <div className="frame1 animated-frame">
                {/* <img src={image} alt="img" className="IMAGE"></img> */}
                <div className="box1">
                Select Your City:<br></br>
          <select
            name="city"
            className="input-text"
            value={selectedCity}
            onChange={handleCityChange}
            
          >
            <option value="" disabled className='cities'>
              Select a City
            </option>
            {cities.map((city, index) => (
              <option key={index} value={city.city_id} className='cities'>
                {city.city_name}
              </option>
            ))}
          </select>
          {showButton && (
            <div style={{textAlign: 'center'}}>
            <button className="menu-btn" onClick={handleSubmit}>
              Submit
            </button>
            </div>
          )}
                </div>
            </div>
            {showFrame && <Retailers cityId={selectedCity} />}
        </>
    );
}
export default RetailerCities;